import { Editor } from '@tiptap/react';
import { forwardRef, Ref, useEffect, useImperativeHandle, useState } from 'react';
import { buildEditor } from './tiptap/build_editor';
import { TiptapEditor } from './tiptap/TiptapEditor';
import { Wikitag, Wikitags } from './tiptap/types';
import { serializer } from './wikitext';

export type RichTextEditorProps = {
   editorId: string;
   initialValue?: string;
   wikitags?: Wikitag[];
   characterCountConfig?: {
      minCharacters: number;
      maxCharacters: number;
   };
};

export type RichTextEditorRef = { editor: Editor | null; getValue: () => string };

export const RichTextEditor = forwardRef(function RichTextEditor(
   { editorId, wikitags = [], initialValue = '', characterCountConfig }: RichTextEditorProps,
   ref: Ref<RichTextEditorRef>
) {
   const [editor, setEditor] = useState<Editor | null>(null);

   useImperativeHandle(ref, () => ({
      editor,
      getValue: () => {
         if (!editor) return '';
         return serializer.serialize(editor.schema.nodeFromJSON(editor.getJSON()));
      },
   }));

   const tags = Wikitags.reduce(
      (tags, tag) => ({
         ...tags,
         [tag]: wikitags.includes(tag),
      }),
      {} as Record<Wikitag, boolean>
   );

   useEffect(() => {
      const editor = buildEditor({
         editorId: editorId,
         wikitags: wikitags,
         content: initialValue,
         characterCountConfig,
      });
      setEditor(editor);
      return () => {
         editor.destroy();
      };
   }, [...Object.values(tags)]);

   if (!editor) {
      return null;
   }

   return <TiptapEditor editor={editor} />;
});
